import React, { SVGProps } from 'react';

const SvgPlusCircleOutlineIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <rect
      width={22.5}
      height={22.5}
      x={0.75}
      y={0.75}
      stroke={props.color || 'currentColor'}
      strokeWidth={1.5}
      rx={11.25}
    />
    <path stroke={props.color || 'currentColor'} strokeLinecap="round" strokeWidth={1.5} d="M12 7v10M17 12H7" />
  </svg>
);
SvgPlusCircleOutlineIcon.defaultProps = {
  width: '24',
  height: '24',
  color: 'currentColor',
};
export default SvgPlusCircleOutlineIcon;
